import braveWalletIcon from '../../../../assets/brave_icon.jpg';
import { NIGHTLY_WALLET_ICON } from './nightlyWalletIcon';

export const BRAVE_WALLET_ICON = braveWalletIcon;
export { NIGHTLY_WALLET_ICON };

export const WALLET_ICON_OVERRIDES: Record<string, string> = {
  brave: BRAVE_WALLET_ICON,
  nightly: NIGHTLY_WALLET_ICON,
};

export interface WalletIconDisplay {
  background: string;
  showBorder: boolean;
  objectFit: 'contain' | 'cover';
  padding: number;
  imageScale?: number;
}

const BRAVE_ICON_DISPLAY: WalletIconDisplay = {
  background: 'transparent',
  showBorder: false,
  objectFit: 'contain',
  padding: 0,
  imageScale: 1.22,
};

const FLAT_ICON_DISPLAY: WalletIconDisplay = {
  background: 'transparent',
  showBorder: false,
  objectFit: 'contain',
  padding: 0.375,
};

const DEFAULT_ICON_DISPLAY: WalletIconDisplay = {
  background: '#fff',
  showBorder: true,
  objectFit: 'cover',
  padding: 0,
};

const FLAT_ICON_SLUGS = new Set(['backpack', 'nightly']);

export function getWalletIconDisplay(slug?: string): WalletIconDisplay {
  const key = slug?.toLowerCase() ?? '';
  if (key === 'brave') return BRAVE_ICON_DISPLAY;
  return FLAT_ICON_SLUGS.has(key) ? FLAT_ICON_DISPLAY : DEFAULT_ICON_DISPLAY;
}
